/**
 * These are static UserLogin account ID's 
 * which can be referenced by ID.
 */
export const LOGINS = {
    ID_SYSDBA: 50
}

export const isSysdbaAccount = (loginId: number): boolean => {
    return loginId === LOGINS.ID_SYSDBA;
}